import React from 'react';

const Question2 = () => {
    return (
        <div>
            <h1 className='text-3xl my-3'>2. What are the differences between props and state?</h1>
            <p className='my-3 font-bold'>Differences between props and state are given below: </p>
            <div className="overflow-x-auto">
                <table className="table w-full">
                    <thead>
                        <tr>
                            <th></th>
                            <th>props</th>
                            <th>state</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>1</th>
                            <td>The Data is passed from one component to another.</td>
                            <td>The Data is passed within the component only.</td>
                        </tr>
                        <tr className="active">
                            <th>2</th>
                            <td>It is Immutable (cannot be modified).</td>
                            <td>It is Mutable ( can be modified).</td>
                        </tr>
                        <tr>
                            <th>3</th>
                            <td>Props can be used with state and functional components.</td>
                            <td>State can be used only with the state components/class component (Before 16.0).</td>
                        </tr>
                        <tr className="active">
                            <th>4</th>
                            <td>Props are read-only..</td>
                            <td>State is both read and write.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Question2;